import { routesBuilder } from '@guiker/shared-framework'

import { Agreement, PropRental, PropRentalWriteModel } from '../../../entity'
import { paths } from '../paths'
import { routes as idNestedRoutes } from './:id'
import { readAllPropRentalsQueryParamsSchema, updatePropRentalAgreementSchema } from './schemas'

const { buildPut } = routesBuilder<PropRental, PropRentalWriteModel>()({ basePath: paths.propRentals.withId.path })
const { buildGet } = routesBuilder<PropRental, PropRentalWriteModel>()({ basePath: paths.propRentals.path })
const listingNested = routesBuilder<PropRental, PropRentalWriteModel>()({
  basePath: paths.listing.withId.propRental.path,
})

export const routes = {
  ...idNestedRoutes,
  readAllPropRentals: buildGet({
    paginated: true,
    queryParamsSchema: readAllPropRentalsQueryParamsSchema,
  }),
  readOnePropRentalByListingId: listingNested.buildGet({}),
  readOnePropRentalFeeByListingId: listingNested.buildGet({
    path: '/fee',
    response: null as Agreement['fee'],
  }),
  readLegacyIdsForPropertyOwner: buildGet({
    path: '/property-owner/:userId/legacy-ids',
    response: null as number[],
  }),
  updatePropRentalAgreement: buildPut({
    path: '/agreement',
    payloadSchema: updatePropRentalAgreementSchema,
  }),
}
